// import errorMessage from './message/zh'

export default {
  errorMsg: 'Error Message',
  confirm: 'Confirm',
  save: 'Save',
  cancel: 'Cancel',
  copyright: 'Copyright© 2013-2026 WallTech Limited. All rights reserved',
  forTheRecord: '沪ICP备14001465号',
  trackingNo: 'Tracking Number',
  consignmentId: 'Consignment ID',
  track: 'Track',
  success: 'Success',
  message: {
    inputRequired: 'Please input ',
    selectRequired: 'Please select ',
    userEmailRequired: 'Please input your e-mail account',
    userEmailFormat: 'Email format is incorrect',
    retrieveTips: 'After confirmation, an email will be sent to the mailbox for password reset',
    passwordFormat: 'Password must be 6-20 characters with uppercase, lowercase, and numbers',
    passwordNotMatch: 'The confirmed password must be consistent with the new password entered',
    passwordExpired: 'Your password has expired. Please contact your administrator to reset it before logging in.',
    ipNotAllowed: 'Your IP address {ip} is not allowed. Access denied',
    oauthUserNotMatched: 'No matching eTower user was found for this account. Please contact your administrator.',
    oauthServiceUnavailable: 'The identity service is temporarily unavailable. Please try again later.',
    superAdminOnly: 'Only super admin accounts are allowed to sign in.',
    deviceNotRegistered: 'This browser or device is not registered. Access denied. To use a new browser, please contact IT',
    passwordChangeSuccess: 'Password changed successfully',
    passwordChangeFailed: 'Password change failed',
    passwordResetSuccess: 'Password reset successfully. The new password has been sent to the user\'s registered email.',
    passwordResetFailed: 'Password reset failed. Please try again later or contact the system administrator.',
    passwordResetConfirm: 'Reset this user\'s password? A new password will be generated per the password policy and sent to their registered email.',
    sendEmailFailed: 'Failed to send email. Please try again later.'
  },
  login: {
    hello: 'Hello!',
    welcomeToSignIn: 'Welcome to Sign In',
    emailAccount: 'Email Account',
    password: 'Password',
    signIn: 'Sign In',
    signInWithMicrosoft: 'Sign in with Microsoft',
    thirdPartyLogin: 'Third Party Login',
    forgotPassword: 'Forgot password?',
    chooseAnAccount: 'Choose an Account',
    retrievePassword: 'Retrieve Password',
    sendEmail: 'Send Email',
    back: 'Back',
    backToLoginPage: 'Back to login page',
    resetPassword: 'Reset Password',
    setPassword: 'Set Password',
    currentPassword: 'Current Password',
    logout: 'Logout'
  },
  common: {
    login: 'Login',
    loading: 'Loading...',
    sessionTimeout: 'Your session is timed out, please login again !',
    warning: 'Warning',
    backToLogin: 'Back to login',
    details: 'Details',
    copy: 'Copy',
    translate: 'Translate',
    info: 'Info',
    copySuccess: 'Successfully Copied',
    copyFailed: 'Copy failed',
    error: 'Error',
    pleaseSelectLanguage: 'Please select the target language',
    userEmail: 'User Email',
    login2: 'LOGIN',
    placeholder: 'Enter up to 30 tracking numbers/consignment IDs, one per line.'
  },
  spww: {
    home: 'Home',
    placeholder: 'Enter up to 30 tracking numbers, one per line',
    contactUs: 'Contact Us: atcecommercesese@gruposese.com',
    noEventFound: 'No event found.',
    languageSelect: 'Please select the target language',
    trackingNo: 'Tracking No',
    forFurtherInformation: 'For further information'
  },
  ubi: {
    home: 'HOME',
    logOut: 'LOG OUT',
    topTipsTitle: 'UBI SmartParcel PACKAGE TRACKING',
    topTipsContent: 'End-to-end Cross-Border Logistics Integrator | B2C | B2B2C | B2B',
    contactUs: 'Contact Us: 400-017-6662 ubics-dlc@gotoubi.com'
  },
  nodes: {
    inf: 'Closed Shipment',
    rcv: 'A-Scan',
    scn: 'Despatched',
    lhl: 'Planning Depart',
    scnDes: 'Destination Scan',
    dld: 'Delivered'
  },
  navbar: {
    logOut: 'Logout',
    loginIn: 'Log in',
    changePassword: 'Change Password',
    newPassword: 'New Password',
    confirmpassword: 'Confirm Password',
    passwordLabelWidth: '140px'
  }
}
